<template>
  <section class="terms">
    <auth-layout name="terms">
      <template #body>
        <div class="title">
          <h3 v-text="`SMART SOLUTION ${$t('common.b_signup')}`"></h3>
        </div>
        <div class="content">
          <form>
            <fieldset>
              <dl class="block">
                <dt class="checkbox">
                  <label @click.prevent="setAllTermChecked">
                    <input v-model="term.isAllTermChecked" type="checkbox" />
                    <span v-text="$t('agree_with_policies')"></span>
                  </label>
                </dt>
              </dl>
              <dl class="block">
                <dt class="checkbox">
                  <label>
                    <input
                      v-model="term.isServiceTermChecked"
                      type="checkbox"
                    />
                    <span>
                      SMART SOLUTION {{ $t('common.t_term') }}
                      <span v-text="`(${$t('essential')})`"></span>
                    </span>
                  </label>
                </dt>
                <dd>
                  <div class="text" v-html="fetchedPolicyTOS"></div>
                </dd>
              </dl>
              <dl class="block">
                <dt class="checkbox">
                  <label>
                    <input
                      v-model="term.isPrivateTermChecked"
                      type="checkbox"
                    />
                    <span>
                      {{ $t('common.t_policy') }}
                      <span v-text="`(${$t('essential')})`"></span>
                    </span>
                  </label>
                </dt>
                <dd>
                  <div class="text" v-html="fetchedPolicyPrivacy"></div>
                </dd>
              </dl>
            </fieldset>
            <div class="button-box">
              <Button
                type="button"
                class="gray"
                :value="$t('dont_agree')"
                @click.native="$router.back()"
              />
              <Button
                type="button"
                class="primary"
                :value="$t('agree')"
                @click.native="goToSignUp"
              />
            </div>
          </form>
        </div>
      </template>
    </auth-layout>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import eve from '@src/commonEvent';
import { exceptHandler } from '@action/util';
import authLayout from '@layouts/authLayout.vue';
import Button from '@components/Button.vue';

export default {
  name: 'terms',
  head: {
    title: {
      inner: 'Terms',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Please Check Our Terms and Privacy Policies - Smart Solution',
      },
    ],
  },
  components: {
    authLayout,
    Button,
  },
  watch: {
    term: {
      handler(data) {
        if (!data.isServiceTermChecked || !data.isPrivateTermChecked) {
          data.isAllTermChecked = false;
        } else if (data.isServiceTermChecked && data.isPrivateTermChecked) {
          data.isAllTermChecked = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['fetchedPolicyTOS', 'fetchedPolicyPrivacy']),
  },
  data() {
    return {
      term: {
        isAllTermChecked: false,
        isServiceTermChecked: false,
        isPrivateTermChecked: false,
      },
    };
  },
  async created() {
    try {
      await this.$store.dispatch('FETCH_POLICY_TOS');
      await this.$store.dispatch('FETCH_POLICY_PRIVACY');
    } catch (err) {
      exceptHandler(err);
    }
  },
  methods: {
    setAllTermChecked() {
      this.term.isAllTermChecked = !this.term.isAllTermChecked;
      this.term.isServiceTermChecked = this.term.isAllTermChecked;
      this.term.isPrivateTermChecked = this.term.isAllTermChecked;
    },

    goToSignUp() {
      if (!this.term.isAllTermChecked) {
        alert(eve.Lang.t('common.t_need_agree'));
        return;
      }

      this.$router.push('/signup');
    },
  },
};
</script>

<style scoped lang="scss">
.terms {
  .title {
    padding: 18px 0;
    border-bottom: 1px solid $gray-e6;

    h3 {
      font-size: 14px;
      text-align: center;
    }
  }

  .content {
    padding: 16px 0;

    dl {
      padding: 0px 10px 5px;

      dt {
        label {
          font-size: 12px;

          span {
            font-size: 12px;
          }
        }
      }

      dd {
        overflow-y: scroll;
        height: 130px;
        margin: 0px;
        padding: 8px;
        border: 1px solid $gray-e6;
        background: $white;

        .text {
          width: 100%;
          height: 100%;
        }
      }
    }

    .button-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 12px 0;

      .button {
        width: 47%;
      }
    }
  }
}
</style>
